/**
 * The JSON value type, and the two guards every boundary in this system needs.
 *
 * `wire/` sits under `safety/` in the layering for the same reason `manifest/`
 * does: the envelope has to be understood in a browser frame, in a Durable
 * Object and in a bare Node test, so it may not depend on any of them.
 *
 * NOTE what this module is NOT. It does not decide whether a value is safe to
 * send — that is `safety/inspectJsonSafety`, which catches the Map trap and
 * everything shaped like it. This is the far cheaper question of "did the thing
 * that arrived off the socket have the shape we require", asked at the point of
 * parse so that no later layer has to re-ask it.
 */

export type JsonValue = string | number | boolean | null | JsonValue[] | { [k: string]: JsonValue };

export type JsonObject = { [k: string]: JsonValue };

export function isJsonObject(value: unknown): value is JsonObject {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function isNonEmptyString(value: unknown): value is string {
  return typeof value === "string" && value.length > 0;
}
